export const generateId = () =>
  `block-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;

export const createBlock = (type = 'text', content = '', props = {}) => ({
  id: generateId(),
  type,
  content,
  props,
  children: [],
});
